module.exports = __webpack_public_path__ + "img/1-4.6eabcbf4.png";